import { eParticaAction } from "./ParticaEvent";

export interface ButtonConfig {
	action: eParticaAction;
	label: string;
	type: ButtonType;
	status: ButtonStatus;
	icon: string;
	title: string;
	help: string;
}

export enum ButtonStatus {
	Enabled,
	Disabled
}

export enum ButtonType {
	OK,
	Cancel,
	Clear,
	Normal,
	Highlight
}
